import React from 'react';
import { Link } from 'react-router-dom';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import { withStyles } from '@material-ui/core/styles';
import { Button } from 'react-admin';

const styles = {
    button: {
        marginTop: '10px'
    }
};

const AddSystemRoleButton = ({ classes, record }) => (
    <Button
        variant="contained"
        component={Link}
        to={`/user_global_role/create/${record.id}`}
        label="Add System Role"
        className={classes.button}
    >
        <AddCircleOutlineIcon />
    </Button>
);

export default withStyles(styles)(AddSystemRoleButton);